import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { MediaModule, NavigationModule } from '@spartacus/storefront';
import { GenericLinkModule } from '../generic-link/generic-link.module';
import { FooterComponent } from './footer.component';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    GenericLinkModule,
    NavigationModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: FooterComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [FooterComponent],
})
export class FooterModule {}
